import { mediaQuery } from './utils/media-query';


import prestashop from 'prestashop';

prestashop.responsive = prestashop.responsive || {};

prestashop.responsive.current_width = window.innerWidth;
prestashop.responsive.min_width = 1199;
prestashop.responsive.mobile = prestashop.responsive.current_width <= prestashop.responsive.min_width;



$(document).ready(() => {

  mediaQuery(
    'min',
    'width',
    '992',
    () => {
      // Desktop do anything
      console.log('Hola soy Desktop');
      //movemos los p de los iconos del header dentro del <a> para poder darle display flex
      jQuery(".col-header-right #header-user-btn a").each(function(){
        jQuery(this).next('p').appendTo(this);
      });

      moveProductElementsDesktop();
      scrollSectionsDesktop();
      cloneProductImg();      
    },
    () => {
      // Mobile do anything
      console.log('Hola soy Mobile');

      
      scrollSectionsMobile();
      cloneProductImg();
      moveVentajasMobile();
      moveDevolucionesMobile();
      
    }
    );
    mediaQuery(
      'min',
      'width',
      '768',
      () => {
        // Desktop do anything
        console.log('Hola soy Desktop 768');
        moveProductElementsTablet();
      },
      () => {
        addToCartBarMobile ();
        //movemos el boton de whatsapp y de email del footer a la columna de los telefonos - solo para mobile
        jQuery('#footer .col-wp-desktop').appendTo('#footer .contact-page-info');

    }
  );
   
});

//Functions para todas las resoluciones
movePostImg();
moveRelatedProducts();
cleanReviewsString();
blogCategoriesFilter();
hideReviews();

function addToCartBarMobile () {
  //check if body class exists to run ths function
  if (jQuery("body#product")[0]){
    let price = jQuery('.precio-producto .current-price .current-price-value').html();
    let priceBox = '<div class="price-box-custom">'+price+'<span>Impuestos incluidos</span></div>';
    jQuery('.product-add-to-cart .add-to-cart').html('Añadir');    
    jQuery( '<div class="price-box-custom">'+price+'<span>Impuestos incluidos</span></div>' ).prependTo( ".product-add-to-cart .product-quantity" );
    //console.log(priceBox);
  }
}
function moveRelatedProducts() {
  //check if body class exists to run ths function
  if (jQuery("body#product")[0]) {
    jQuery('section.product-accessories').insertAfter('#main-product-wrapper .product-info-row');
  }
}
function cloneProductImg() {
  if (jQuery("body#product")[0]) {
    jQuery('.product-lmage-large .img-fluid').clone().prependTo('.product-sections .product-description-section .box-image-cloned');
  }
}

function hideReviews() {  
  if (jQuery("body#product")[0]) {
    if (jQuery("#iqitreviews-list")[0]) {
      jQuery('#iqit-reviews-tab').show();
    }else{
      jQuery('#iqit-reviews-tab').hide();
      jQuery('body').addClass('noreviews');
    }
  }
}
//move elementos de la pagina de productos
function moveProductElementsTablet() {
  //check if body class exists to run ths function
  if (jQuery("body#product")[0]) {
    jQuery('.product-title-custom').prependTo('#main-product-wrapper .product-info-row .col-product-info');
    // jQuery('.product-add-to-cart').prependTo('.product-sidebar');
    // jQuery('.product-prices').prependTo('.product-sidebar');
    // jQuery('.btn-opiniones').appendTo('.iqitreviews-simple');
  }
}
function moveProductElementsDesktop() {
  //check if body class exists to run ths function
  if (jQuery("body#product")[0]) {
    jQuery('.product-title-custom').prependTo('#main-product-wrapper .product-info-row .col-product-info');
    //jQuery('.product-add-to-cart').prependTo('.product-sidebar');
    jQuery('#add-to-cart-or-refresh').prependTo('.product-sidebar');
    jQuery('.product-prices').prependTo('.product-sidebar');
    jQuery('.btn-opiniones').appendTo('.product_header_container .iqitreviews-simple');
    //close loading layer
    jQuery(document).on('hidden.bs.modal', '#blockcart-modal', function (event) {
      jQuery('#main').removeClass('-combinations-loading');
    });
  }
}
  
function movePostImg () {
  if (jQuery("body#module-ph_simpleblog-single")[0]) {
    jQuery('.page-title .category-custom').insertBefore('.page-title>span');
    jQuery('.page-title span img').insertAfter('.page-title span').not( ".category-custom" );
  }
}
// SCROLL TO SECTIONS
function scrollSectionsMobile() {
  $('.product-extra-buttons a.nav-link').on('click', function(event) {
    var $anchor = $(this);    
    $('html,body').animate({scrollTop: ($($anchor.attr('href')).offset().top - 60)}, 'slow');
    event.preventDefault();
  });
}
function scrollSectionsDesktop() {
  $('.product-extra-buttons a.nav-link').on('click', function(event) {
    var $anchor = $(this);    
    $('html,body').animate({scrollTop: ($($anchor.attr('href')).offset().top - 140)}, 'slow');
    event.preventDefault();
  });
}
// Product Item QTY for desktop
productItemQty();
function productItemQty() {
  var $qty = $('#product .qty');
  
  $qty.each(function (i, e) {
      var $input = $(this).children('input[type=number]');
      var $minus = $(this).children('.productitem-qty-minus');
      var $plus = $(this).children('.productitem-qty-plus');
      var $hiddenField = $(this).parents('.productitem-tocart-form').children('input[name=qty]');
      
      $minus.on('click', function () {
        var q = parseInt($input.val());
        
        if (q <= 1) {
          $input.val(1);
          $hiddenField.val(1);
        } else {
          $input.val(q - 1);
              $hiddenField.val(q - 1);
            }
      });
      
      $plus.on('click', function () {
        var q = parseInt($input.val());
        $input.val(q + 1);
        $hiddenField.val(q + 1);
      });
    });
  }
  // Circular progress bar para los reviews - acepta valores decimales
  circularProgressBar(4.5); //esto lo he puesto de ejemplo para llamar la function
  function circularProgressBar(value) {
    let valueNew = value;
    let rating = valueNew*20;
    console.log(value);
    $('.review-circle .circularBar').removeAttr("style");
    $('.review-circle .circularBar').attr("style", "--progress:" + rating);
    $('.review-circle .circularBar .avg').html(valueNew);

    if (jQuery("body#product")[0]) {
      jQuery('.section-title .iqitreviews-nb').appendTo('.nro-reviews .reviews');
    }
  }
  function moveVentajasMobile() {
    jQuery('.section-ventajas').insertBefore(".elementor-element-h84fgn9");
  }
  /** Remove word "reviews" and show number within parenthesis */
  function cleanReviewsString() {
    let reviews = jQuery('body#product .iqitreviews-nb').html();
    let number = Number.parseInt(reviews, 10);
    jQuery('body#product .iqitreviews-nb').html('('+number+')');
    console.log('Numero: '+number);
  }

  /** Move product blocks "Devoluciones y Envios" to another container in mobile */
  function moveDevolucionesMobile() {
    jQuery('.box-info-tienda').appendTo('.section-aditional-info-custom');
  }
  
  /** Custon button for blog categories filter */
  function blogCategoriesFilter() {
    jQuery('.blogSubcat').appendTo('.page-header');
    let list = jQuery('.blogSubcat__list');
    let trigger = jQuery('.btn-categorias-blog');
    list.hide();
    trigger.on('click', function(){
      list.toggle();
    });
  }
  


// WEBPACK FOOTER //
// ./js/theme.js